import { Component, computed, effect, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingSpinnerComponent } from "../../../../shared/components/loading-spinner/loading-spinner.component";
import { AddCatalogDialogComponent } from '../../dialogs/add-catalog-dialog/add-catalog-dialog.component';
import { Catalog } from './models/catalog.model';
import { CatalogService } from './services/catalog.service';
import { WorkspaceService } from '../workspaces-tab/services/workspace.service';
import { MatSort, MatSortable, MatSortModule } from '@angular/material/sort';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-catalogs-tab',
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    LoadingSpinnerComponent,
    MatSortModule,
    DatePipe,
],
  templateUrl: './catalogs-tab.component.html',
  styleUrl: './catalogs-tab.component.css'
})
export class CatalogsTabComponent {
  catalogService = inject(CatalogService);
  private workspaceService = inject(WorkspaceService);

  catalogsColumns: string[] = ['name', 'creationDate', 'status'];
  catalogsDataSource = new MatTableDataSource<Catalog>;

  hasWorkspace = computed(() => this.workspaceService.workspaces().some(workspace => workspace));

  private _sort!: MatSort;
    @ViewChild(MatSort) set matSort(sort: MatSort) {
      if (sort) {
        this._sort = sort;
        this.catalogsDataSource.sort = this._sort;
  
        // set default sort on load
        if (!this._sort.active && this.catalogsDataSource.data.length) {
          Promise.resolve().then(() => {
            this._sort.sort({ id: 'creationDate', start: 'desc' } as MatSortable);
          });
        }
      }
    }
 
  constructor( private dialog: MatDialog ) {
    this.catalogsDataSource = new MatTableDataSource<Catalog>([]);

    effect(() => {
      this.catalogsDataSource.data = this.catalogService.catalogs() as Catalog[] ?? [];
    });
  }

  ngAfterViewInit() {
    this.catalogsDataSource.sort = this._sort;

    // provide custom sorting accessor for complex properties
    this.catalogsDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'creationDate': 
          return item.createdAt ? new Date(item.createdAt).getTime() : 0;
        default: 
          const value = (item as any)[property];
          return typeof value === 'string' ? value.toLowerCase(): value ?? '';
      }
    };
  }

  openAddCatalogDialog(): void {
    const dialogRef = this.dialog.open(AddCatalogDialogComponent, {
      width: '560px', 
      disableClose: true,
    });

    dialogRef.beforeClosed().subscribe((catalog: Catalog) => {
      if (catalog) {
        const currentCatalogs = this.catalogService.catalogs();
        currentCatalogs.push(catalog);
        this.catalogService.catalogs.set([...currentCatalogs]);
      }
    });
  }
}
